<template>
  <div class="form-group d-flex align-items-center">
    <input
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
      v-bind:value="value"
      type="number"
      class="form-control col-6"
      id="number"
    />
   <!-- <div class="col-6 mr-2"><code :style="{fontSize: value + 'px'}"> Text Size {{ value }} px</code></div> -->
    
  </div>
</template>

<script>
export default {
  name: "TextSize",
  inheritAttrs: false,
  props: {
    label: String,
    value: [String, Boolean, Array, Object, Number],
  },
};
</script>

<style>
</style>